<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 357 368.5"
    >
      <g>
        <polygon
          :fill="iconColor"
          points="178.5,0 193.3,30 226.3,34.8 202.4,58.1 208.1,91 178.5,75.5 148.9,91 154.6,58.1 130.7,34.8
          163.7,30"
        />
        <g>
          <path
            :fill="iconColor"
            d="M244,368.5H113V138c0-15.7,12.8-28.5,28.5-28.5h74c15.7,0,28.5,12.8,28.5,28.5V368.5z M131,350.5h95V138
            c0-5.8-4.7-10.5-10.5-10.5h-74c-5.8,0-10.5,4.7-10.5,10.5V350.5z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M131,368.5H0V225c0-15.7,12.8-28.5,28.5-28.5h74c15.7,0,28.5,12.8,28.5,28.5V368.5z M18,350.5h95V225
            c0-5.8-4.7-10.5-10.5-10.5h-74c-5.8,0-10.5,4.7-10.5,10.5V350.5z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M357,368.5H226V273c0-15.7,12.8-28.5,28.5-28.5h74c15.7,0,28.5,12.8,28.5,28.5V368.5z M244,350.5h95V273
            c0-5.8-4.7-10.5-10.5-10.5h-74c-5.8,0-10.5,4.7-10.5,10.5V350.5z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "LeaderboardIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
